import IframeResizer from "iframe-resizer-react";
import { useEffect, useState } from "react";
import { getCognitoAccessToken } from "src/services/Api";
import { graphqlRequest as request } from "src/services/GraphQL/GraphQL";
import { GET_NEXT_BEE_APP_URL } from "src/services/GraphQL/graph.query";
import { useSelector } from "react-redux";
import styles from "./ReferralProgram.module.scss";


const ReferralProgram = () => {
  const [src, setSrc] = useState(null);
  const [loading, setLoading] = useState(true);
  // User data
  const email = localStorage.getItem("username");
  const firstName = useSelector((state: any) => state.auth.firstName);
  const lastName = useSelector((state: any) => state.auth.lastName);
  
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://crosscountry.nextbeeapp.com/js/widget.js";
    document.body.appendChild(script);

    async function main() {
      try {
        const authToken = await getCognitoAccessToken();
        const result: any = await request(GET_NEXT_BEE_APP_URL, { email, firstName, lastName }, authToken);
        if (result.getNextBeeAppUrl.code === 200) {
          const appUrl = result?.getNextBeeAppUrl?.content?.appUrl
          setSrc(appUrl);
        }
      } catch (error: any) {
        console.error("Exception occurred:");
        console.error(error.message);
      } finally {
        setLoading(false);
      }
    }
    main();
    window.scrollTo(0, 0);

    return () => {
      document.body.removeChild(script);
    };
  }, []);
  if (loading) {
    return <div className={styles.loadingWrapper} />;
  }
  return (
    <>
      {src && (
        <IframeResizer
          className={styles.referralIframe}
          id="incompleteProfilePage"
          scrolling
          src={src}
          heightCalculationMethod="documentElementScroll"
        />
      )}
    </>
  );
};

export default ReferralProgram;
